import { HeadCell } from 'shell/components/shared/table/types';
import { FeatureAuthClient } from 'system/view-models/feature-auth-list';
import * as yup from 'yup';

export const headCells: HeadCell<FeatureAuthClient, keyof FeatureAuthClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaGroupsFilter = yup.object({});
